import { useId } from "react";
import { ACCOUNTING_DATE_BOUNDS } from "@/shared/configs/accountingDateBounds";
import { Input } from "@/shared/ui/Input";
import { getTodayParisDateString } from "@/shared/utils/date.utils";

export const STOCK_EXPIRY_DISABLED_HINT = "Disponible uniquement pour une entrée de stock (unités créditées).";

// The email is opt-in (off by default), so the copy must not promise it to everyone
const STOCK_EXPIRY_ALERT_HINT = "Un email est envoyé 30 jours avant aux élus qui ont activé cette alerte (Mes préférences > Notifications), si du stock reste.";

type StockExpiryDateFieldProps = {
  value: string
  onChange: (value: string) => void
  isEnabled: boolean
  isBusy: boolean
};

const StockExpiryDateField = ({
  value, onChange, isEnabled, isBusy,
}: StockExpiryDateFieldProps) => {
  const inputId = useId();
  const hintId = useId();

  return (
    <div className="space-y-1">
      <label htmlFor={inputId} className="text-[12px] leading-tight text-muted-foreground">
        Billets valables jusqu&apos;au (facultatif)
      </label>
      <Input
        id={inputId}
        type="date"
        min={getTodayParisDateString()}
        max={ACCOUNTING_DATE_BOUNDS.max}
        value={isEnabled ? value : ""}
        onChange={(event) => onChange(event.target.value)}
        className="h-8 !text-[12px] md:!text-[12px] leading-tight max-w-[200px]"
        disabled={isBusy || !isEnabled}
        aria-describedby={hintId}
      />
      <p id={hintId} className="text-[11px] text-muted-foreground">
        {isEnabled ? STOCK_EXPIRY_ALERT_HINT : STOCK_EXPIRY_DISABLED_HINT}
      </p>
    </div>
  );
};

export default StockExpiryDateField;
